import { render, staticRenderFns } from "./landing_page.vue?vue&type=template&id=3b70648e&scoped=true&"
import script from "./landing_page.vue?vue&type=script&lang=js&"
export * from "./landing_page.vue?vue&type=script&lang=js&"
import style0 from "./landing_page.vue?vue&type=style&index=0&id=3b70648e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b70648e",
  null
  
)

export default component.exports